import { createApiSlice } from "@common";
import {
  CURD_CUSTOMERS_ACCOUNT_STATUS
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addCustomerAccountStatus",
    method: "post",
    url: CURD_CUSTOMERS_ACCOUNT_STATUS,
    stateKey: "message",
  },
  {
    name: "getCustomerAccountStatus",
    method: "get",
    url: CURD_CUSTOMERS_ACCOUNT_STATUS,
    stateKey: "data",
  },
  {
    name: "updateCustomerAccountStatus",
    method: "put",
    url: CURD_CUSTOMERS_ACCOUNT_STATUS,
    stateKey: "message",
  },
  {
    name: "deleteCustomerAccountStatus",
    method: "delete",
    url: CURD_CUSTOMERS_ACCOUNT_STATUS,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "customerAccountStatus",
  apiConfig,
  customReducers,
);
const customerAccountStatusSlice = slice;
// Export the slice's reducer
export default customerAccountStatusSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addCustomerAccountStatus,
  getCustomerAccountStatus,
  updateCustomerAccountStatus,
  deleteCustomerAccountStatus
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
  actions;
